import React from 'react';
import { Route } from 'react-router';
import * as Screens from '../screens';
import { userRoutePaths } from './route-paths';

/**
 * Route definitions for the user module.
 *
 * @example
 * <Routes>{userRoutes}</Routes>
 */
export const userRoutes = [<Route path={userRoutePaths.login} element={<Screens.Login />} key="login" />, <Route path={userRoutePaths.logout} element={<Screens.Logout />} key="logout" />, <Route path={userRoutePaths.profile} element={<Screens.Profile />} key="profile" />];